'use strict';

function _MoneyController() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AccountController];

  this.loanStateRoutingEnabled = false; // Used on /loans | /loans/preapproval | /loans/apply

  this._history = new History();
  this._errorInitialized = false;
  this._requestErrors = {}; // keep track of errors for parallel loanservice requests
  this._currentClass = null;

  this._loansIndexModelReady = $.Deferred();
  this._loanOffersModelReady = $.Deferred();
  this._liquidLoanModelReady = $.Deferred();
  this._loanApplicationsIndexModelReady = $.Deferred();
  this._lenderModelReady = $.Deferred();
  this._accountModelReady = $.Deferred();
  this._setupDependentDataPromise = $.Deferred();

  this._loansIndexUIReady = $.Deferred();
  this._loanOffersUIReady = $.Deferred();
  this._liquidLoanUIReady = $.Deferred();
  this._loanApplicationsIndexUIReady = $.Deferred();

  this._liquidLoanPath = 'money.loans.loans[0]';
  this._loanApplicationsPath = 'money.applications.loan_applications[0]';

  // Loan Application Flow
  this._indexLoanApplicationsAction = 'account.index_loan_applications';
  this._createLoanApplicationsAction = 'create_loan_application';
  this._updateLoanApplicationsAction = 'update_loan_application';
  this._createLoanApplicationsEmploymentAction = 'create_loan_application_employment';
  this._updateLoanApplicationsEmploymentAction = 'update_loan_application_employment';
  this._loanApplications = [];

  this._DEBUG = false;
  if (this._DEBUG) this.pageName = '[MoneyController]';

  this.init = function () {
    this._super();
    this._productSettings = new ProductSettings(this.presenter);

    if (!this.presenter.models.money) {
      this.presenter.createModel('money', {
        data: {}
      });
    }

    // Check for eligibility
    if (!this.presenter.hasAction('account.index_loans') && (!!this.presenter.models.account.profile_completed_at || this.presenter.models.account.verification_level === 4)) {
      this.presenter.createModel('money.loans', {
        data: {
          declined: true
        }
      });
      this._loansIndexModelReady.resolve();
      this._liquidLoanModelReady.resolve();
      this._lenderModelReady.resolve();
      this._loansIndexUIReady.resolve();
      this._liquidLoanUIReady.resolve();
      this._loanApplicationsIndexModelReady.resolve();
      this._loanApplicationsIndexUIReady.resolve();
      this._createLoanOffersModel();
      return;
    }

    // Retrieve loan data and offer data
    this._createLoansModel();
    this._createLoanOffersModel();
    this._createLoanApplicationsModel();
    this._createLendersModel();
  };

  this.initAllReady = function () {
    this._super();

    // When models ready, update loan states
    $.when(this._loanOffersModelReady, this._accountModelReady, this._loansIndexModelReady, this._liquidLoanModelReady, this._lenderModelReady, this._loanApplicationsIndexModelReady).done([this._setupDependentData.bind(this) /* Model */]);
    // When models ready for UI, update UI
    $.when(this._setupDependentDataPromise, this._loanOffersUIReady, this._loansIndexUIReady, this._liquidLoanModelReady, this._lenderModelReady, this._loanApplicationsIndexUIReady).done(this.routeMoneyFlow.bind(this));
  };

  // index_loan_application should return all of the updated nested properties
  this._createLoanApplicationsModel = function () {
    if (this.presenter.hasAction('account.index_loan_applications')) {
      if (typeof this.presenter.models.money.applications === 'undefined' || !this.presenter.models.money.applications._initialized) {
        if (!this._requestErrors.applications) {
          this._onGetLoanApplicationsCallbackId = this.presenter.addCallbackToAction('account.index_loan_applications', this._onGetLoanApplicationsUICallback.bind(this));

          if (typeof this.presenter.models.money.applications === 'undefined') {
            this.presenter.performAction('account.index_loan_applications', null, this._onGetLoanApplicationsCallback.bind(this));
          }
        } else {
          this._requestErrors.applications.retry();
        }
      } else {
        this._loanApplicationsIndexModelReady.resolve();
        this._loanApplicationsIndexUIReady.resolve();
      }
    } else {
      console.warn('cannot retrieve loan applications: missing loans application index link');
      // this._onGetLoanApplicationsUICallback();
    }
  };

  this._onGetLoanApplicationsCallback = function (data, response) {
    if (!response || response === 200) {
      this.presenter.createModel('money.applications', {
        data: data
      });
      this._loanApplicationsIndexModelReady.resolve();

      if (this._requestErrors.applications) delete this._requestErrors.applications;
      this._checkRequestErrors();
    }
  };

  this._onGetLoanApplicationsUICallback = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this._requestErrors.applications = request;
      if (!this._errorInitialized || this.declaredClass != this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, this._connectionIssueConfig);
      }
    } else {
      // successful callback action for index loans application
      if (this._onGetLoanApplicationsCallbackId) {
        this.presenter.removeCallbackFromAction(this._indexLoanApplicationsAction, this._onGetLoanApplicationsCallbackId);
      }

      this._loanApplicationsIndexModelReady.resolve();
      this._loanApplicationsIndexUIReady.resolve();
    }
  };

  this.createLoanApplication = function (offerName, callbacks) {
    if (this.presenter.hasAction('money.applications.create_loan_application') && offerName === 'liquid') {
      this.presenter.performAction('money.applications.create_loan_application', {
        product: offerName
      }, this._onCreateLoanApplication.bind(this, callbacks));
    } else if (callbacks.failure) {
      callbacks.failure({
        errors: [{
          code: 404,
          key: 'no_action_error'
        }]
      }, 404);
    }
  };

  this._onCreateLoanApplication = function (callbacks, data, response, request) {
    if (response === 200) {
      this.presenter.updateModel('money.applications', null, function (callbacks, data, response, request) {
        // Loan application object
        var loanApps = this.presenter.getModelProperty('money.applications.loan_applications');
        if (loanApps && loanApps.length > 0) {
          for (var i = 0; i < loanApps.length; i++) {
            this._loanApplications[i] = new LoanApplication(this.presenter, loanApps[i]);
          }
        }

        if (callbacks.success) {
          var appId = data.id;
          var index = -1;
          for (var i = 0; i < this._loanApplications.length; i++) {
            if (this._loanApplications[i].id === appId) {
              index = i;
            }
          }
          callbacks.success(this._loanApplications[index], data, response, request);
        }
      }.bind(this, callbacks, data, response, request));
    } else if (callbacks.failure) {
      callbacks.failure(data, response, request);
    }
  };

  // Checks if there's an INDEX
  this.hasCreatedLoanApplication = function () {
    if (this._loanApplications.length) {
      return true;
    }
    return false;
  };

  this._createLendersModel = function () {
    if (this.presenter.hasAction('account.index_lenders')) {
      if (!this.presenter.models.money.lenders || !this.presenter.models.money.lenders._initialized) {
        if (!this._requestErrors.lenders) {
          if (typeof this.presenter.models.money.lenders === 'undefined') {
            this.presenter.performAction('account.index_lenders', null, this._onGetLenders.bind(this));
          }
        } else {
          this._requestErrors.lenders.retry();
        }
      } else {
        this._lenderModelReady.resolve();
      }
    } else {
      console.warn('cannot retrieve lenders: missing get lenders link');
    }
  };

  this._onGetLenders = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this._requestErrors.lenders = request;
      if (!this._errorInitialized || this.declaredClass != this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage(request, {
          productLabel: 'Asset'
        }, null, this._connectionIssueConfig);
      }
    } else {
      this.presenter.createModel('money.lenders', {
        data: data
      });
      this._lenderModelReady.resolve();
      if (this._requestErrors.lenders) delete this._requestErrors.lenders;
      this._checkRequestErrors();
    }
  };

  this._createLoanOffersModel = function () {
    // this code 3 times quickly by LoansRouter, DashboardPReapproval, and LoansTopNavigation :/
    if (this.presenter.hasAction('account.get_offer')) {
      if (typeof this.presenter.models.money.offers === 'undefined' || !this.presenter.models.money.offers._initialized) {
        if (!this._requestErrors.offers) {
          this._onGetLoanOffersCallback = this.presenter.addCallbackToAction('account.get_offer', this._onGetLoanOffers.bind(this));

          if (typeof this.presenter.models.money.offers === 'undefined') {
            if (this._DEBUG) console.log('1. [' + this.id + '] performAction account.get_offer.');

            // makes promise resolved too soon for other mogo-pages..
            // this.presenter.createModel('money.offers'); // this will stop firing this 3 times...
            // but if all 3 dont fire the action then they also don't know when things are ready.

            this.presenter.performAction('account.get_offer', null, this._parseLoanOffers.bind(this));
          }
        } else {
          this._requestErrors.offers.retry();
        }
      } else {
        this._loanOffersModelReady.resolve();
        this._loanOffersUIReady.resolve();

        // really dont want this here:
        this._accountModelReady.resolve();
      }
    } else {
      this.presenter.createModel('money.offers');
      console.error('cannot retrieve offers: missing account get_offers link');
    }
  };

  this._parseLoanOffers = function (data, response) {
    var _this = this;

    if (this._DEBUG) console.log('2. [' + this.id + '] _parseLoanOffers direct action callback.');
    if (response === 200) {
      data = this._updateDataForReferrals(data);

      this.presenter.createModel('money.offers', {
        data: data
      });

      this.presenter.updateModel('account', null, function () {
        if (_this._DEBUG) console.log('4. [' + _this.id + '] account model updated.');
        _this._loanOffersModelReady.resolve(); // hmm _onGetLoanOffers & _parseLoanOffers resolve the promise
        _this._accountModelReady.resolve();
        _this.presenter.scanDOM(_this.node);
      });
      if (this._requestErrors.offers) delete this._requestErrors.offers;
      this._checkRequestErrors();
    }
  };

  this._updateDataForReferrals = function (data) {
    // to work with existing offer codebase infrustructure,
    // we simulate an offer record when referral is detected
    // note: payments data is required by code but not real or used here
    // note2: expires_at is also required, so set to far future

    if (data && data.referral && data.referral.referrer_key !== '') {
      var _lendfulOfferData = [{
        amount: 35000,
        apr: 9.9,
        lender_id: 1,
        name: 'lendful',
        offer_type: 'system',
        expires_at: '2050-12-02T16:43:52.000+00:00',
        path: null,
        payments: [{
          amount: 2000,
          biweekly: 47.42,
          display_terms_as: 'year',
          monthly: 103.22,
          term_months: 36,
          terms: 3
        }]
      }];
      // assumption here is offers data in this situation is always empty
      data.offers[0] = _lendfulOfferData;
    }
    return data;
  };

  this._onGetLoanOffers = function (data, response, request) {
    if (this._DEBUG) console.log('3. [' + this.id + '] _onGetLoanOffers registered action callback.');
    if (this.isGeneralConnectionIssue(data, response)) {
      this._requestErrors.offers = request;
      if (!this._errorInitialized || this.declaredClass != this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage(request, {
          productLabel: 'Asset'
        }, null, this._connectionIssueConfig);
      }
    } else {
      this._loanOffersModelReady.resolve(); // hmm  _onGetLoanOffers & _parseLoanOffers resolve the promise
      this._loanOffersUIReady.resolve();
    }
  };

  this._createLoansModel = function () {
    if (typeof this.presenter.models.money.loans === 'undefined' || !this.presenter.models.money.loans._initialized) {
      if (this.presenter.hasAction('account.index_loans')) {
        if (!this._requestErrors.loans) {
          this._onGetLoansModelCallback = this.presenter.addCallbackToAction('account.index_loans', this._onGetLoansModel.bind(this));

          if (typeof this.presenter.models.money.loans === 'undefined') {
            this.presenter.performAction('account.index_loans', null, this._parseLoansModel.bind(this));
          }
        } else {
          this._requestErrors.loans.retry();
        }
      } else {
        console.error('cannot retrieve loans: missing loans index link');
      }
    } else {
      this._loansIndexModelReady.resolve();
      this._loansIndexUIReady.resolve();
      this._updateLiquidLoanModel();
    }
  };

  this._parseLoansModel = function (data, response) {
    if (response === 200) {
      // To prevent new models from overriding the augmented data model
      if (!this.presenter.models.money.loans) {
        this.presenter.createModel('money.loans', {
          data: data
        });
      }

      this._loansIndexModelReady.resolve();

      if (this._requestErrors.loans) delete this._requestErrors.loans;
      this._checkRequestErrors();
    }
  };

  this._onGetLoansModel = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this._requestErrors.loans = request;
      if (!this._errorInitialized || this.declaredClass != this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage(request, {
          productLabel: 'Asset'
        }, null, this._connectionIssueConfig);
      }
    } else if (response === 200) {
      this._updateLiquidLoanModel();
      this._loansIndexModelReady.resolve();
      this._loansIndexUIReady.resolve();
    } else {
      this._loansIndexModelReady.resolve();
      this._loansIndexUIReady.resolve();
      this._liquidLoanModelReady.resolve();
      this._liquidLoanUIReady.resolve();
    }
  };

  this._updateLiquidLoanModel = function () {
    var loansIndex = this.presenter.models.money.loans;
    if (loansIndex.hasOwnProperty('loans') && loansIndex.loans.length) {
      if (!this.presenter.getModelProperty(this._liquidLoanPath + '.next_payment')) {
        // Checks that model exists and secondary call to model has been made to retrieve ASSET data
        // Get active liquid loan
        this.presenter.updateModel(this._liquidLoanPath, null, this._onGetLiquidLoan.bind(this, this._liquidLoanPath));
      } else {
        // Active liquid loan already retrieved
        this._createAdditionalPaymentsModel(this._liquidLoanPath);
      }
    } else {
      // No active loans
      this._liquidLoanModelReady.resolve();
      this._liquidLoanUIReady.resolve();
    }
  };

  this._onGetLiquidLoan = function (modelName, data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized || this.declaredClass != this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage(request, {
          productLabel: 'Asset'
        }, null, this._connectionIssueConfig);
      }
    } else {
      this._createAdditionalPaymentsModel(modelName);
    }
  };

  this._createAdditionalPaymentsModel = function (modelName) {
    // Get additional payments
    if (!this.presenter.getModelProperty(modelName + '.additional_payments') || !this.presenter.getModelProperty(modelName + '.additional_payments._initialized')) {
      this._activeLoanModelCallbackId = this.presenter.addCallbackToAction(modelName + '.index_additional_payments', this._onGetAdditionalPayments.bind(this));

      this.presenter.performAction(modelName + '.index_additional_payments', {
        include_past_and_posted: false
      }, this._parseAdditionalPayments.bind(this, modelName));
    } else {
      // Additional payments exist
      this._onGetAdditionalPayments();
    }
  };

  this._parseAdditionalPayments = function (modelName, data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (!this._errorInitialized || this.declaredClass != this._currentClass) {
        this._currentClass = this.declaredClass;
        this._errorInitialized = true;
        this.invokeConnectionIssuePage(request, {
          productLabel: 'Asset'
        }, null, this._connectionIssueConfig);
      }
    } else {
      // Additional payments retrieved
      this.presenter.createModel(modelName + '.additional_payments', {
        data: data
      });
      this._liquidLoanModelReady.resolve();
    }
  };

  this._onGetAdditionalPayments = function () {
    // Additional payments retrieved
    this._setupAdditionalPaymentVariable();
    this._liquidLoanModelReady.resolve();
    this._liquidLoanUIReady.resolve();
  };

  this._setupAdditionalPaymentVariable = function () {
    this._additionalPayment = null;
    this._liquidLoan = this.presenter.getModelProperty('money.loans.loans[0]');
    var additionalPayments = this._liquidLoan ? this._liquidLoan.additional_payments.loan_additional_payments : null;
    if (additionalPayments) {
      for (var i = 0; i < additionalPayments.length; i++) {
        if (additionalPayments[i].payment_type === 'paydown') {
          this._additionalPayment = additionalPayments[i];
          break;
        }
      }
    }
  };

  this._setupDependentData = function () {
    var _this2 = this;

    // Model only
    this._activeOffer = new Offer(this.presenter, 'active');
    this._expiredOffer = new Offer(this.presenter, 'expired');
    this._previousOffer = new Offer(this.presenter, 'previous');

    // also run 3 times for top nav nav and dashboard...
    // needs to wait for account model now as well...

    // Loan application object
    var loanApps = this.presenter.getModelProperty('money.applications.loan_applications');
    if (loanApps && loanApps.length > 0) {
      for (var i = 0; i < loanApps.length; i++) {
        this._loanApplications[i] = new LoanApplication(this.presenter, loanApps[i]);
      }
    }

    var applicationStatus = this._getApplicationStatus();
    var loanStatus = this._getLoanStatus();
    var offerStatus = this._getOfferStatus();
    var aStatus = this._getAgreementsStatus();
    var loanLenderId = this.getLoanLenderId();

    if (this._DEBUG) console.log('6. [' + this.id + '] _setupDependentData : offerStatus', offerStatus);

    // Band-aid:
    // Clear out loan applications if it's a level up offer (loan status + offer status), but
    // application status returns null (indicating there should not be any applications)
    if (offerStatus && offerStatus === 'active' && loanStatus && loanStatus.status && !applicationStatus) {
      this._loanApplications = [];
    }

    // Body-cast:
    // After a offer refresh things runs properly for LoansTopTray,
    // but then resolves inproperty for DashboardMoney and it wipes out referral offer data
    var isReferralOffer = this.presenter.getModelProperty('money.offers.referral') !== null;
    if (isReferralOffer && this.presenter.getModelProperty('money.displayed_offer.0.name') !== 'lendful') {
      var referralOfferData = this._updateDataForReferrals(this.presenter.getModelProperty('money.offers'));
      this.presenter.createModel('money.offers', {
        data: referralOfferData
      });
      this._loanOffersModelReady.resolve();
    }

    // New Digital Loan Application
    if (this.hasCreatedLoanApplication()) {
      var digitalLoanStatus = this._loanApplications[0].getStatus();
      var dlaLenderId = this._loanApplications[0].getApplicationLender();
    }

    this.presenter.addComputedVariable('offerExpireDate', ['money.displayed_offer[0].expires_at'], function (expiry) {
      var eDate = _this2._activeOffer.getExpireDate();
      return eDate ? moment(new Date(eDate)).format('MMM D, YYYY') : '';
    });

    this.presenter.addComputedVariable('preapprovalTerms', ['money.displayed_offer[0].payments'], function (po) {
      var paymentOption = _this2._activeOffer.getOfferPayments();
      if (paymentOption) {
        if (paymentOption && paymentOption.display_terms_as === 'month') {
          return paymentOption.term_months + ' month';
        }
        if (paymentOption && paymentOption.display_terms_as === 'year') {
          return +parseFloat(paymentOption.term_months / 12).toFixed(2) + ' year';
        }
      }
    });

    // new format for expiration day Feb 2019
    this.presenter.addComputedVariable('expiry_days', ['money.displayed_offer[0].expires_at'], function (val) {
      var days = _this2._getDaysBeforeExpiration();
      if (days > 1) {
        return ' in <span class=\'offer-days-expire\'>' + days + '</span> days';
      }
      if (days == 1) {
        return ' in <span class=\'offer-days-expire\'>' + days + '</span> day';
      }
      if (days == 0) {
        return ' <span class=\'offer-days-expire\'>today</span>';
      }
    });

    this.presenter.addComputedVariable('applicationState', ['money.loans.fs_loans'], function () {
      if (applicationStatus) {
        return applicationStatus.status;
      }
      return '';
    });
    this.presenter.addComputedVariable('loanState', ['money.loans'], function () {
      if (loanStatus) {
        return loanStatus.status;
      }
      return '';
    });
    this.presenter.addComputedVariable('offerState', ['money.offers'], function () {
      if (offerStatus) {
        return offerStatus;
      }
      return '';
    });
    this.presenter.addComputedVariable('agreementsState', ['money.loans.fs_loans'], function () {
      if (aStatus) {
        return aStatus;
      }
      return '';
    });

    this.presenter.addComputedVariable('activeOfferName', ['money.offers'], function (val) {
      return _this2._activeOffer.getOfferName() || '';
    });

    this.presenter.addComputedVariable('expiredOfferName', ['money.offers'], function (val) {
      return _this2._expiredOffer.getOfferName() || '';
    });

    this.presenter.addComputedVariable('previousOfferName', ['money.offers'], function (val) {
      return _this2._previousOffer.getOfferName() || '';
    });

    this.presenter.addComputedVariable('daysBeforeExpiry', ['money.displayed_offer[0].expires_at'], function () {
      return _this2._getDaysBeforeExpiration();
    });

    // Loan Lender
    this.presenter.addComputedVariable('loanLenderId', [this._liquidLoanPath + '.lender_id'], function (val) {
      return loanLenderId || '';
    });

    // Digital Loan Application Status
    // TODO: names are getting confusing, name them better later

    this.presenter.addComputedVariable('digitalLoanStatus', ['money.applications'], function (val) {
      if (digitalLoanStatus) {
        return digitalLoanStatus;
      }
      return '';
    });

    this.presenter.addComputedVariable('loanApplicationLenderId', [this._loanApplicationsPath + '.lender_id'], function (val) {
      return dlaLenderId || '';
    });

    if (this._isEligibleForLoanProduct()) {
      this._liquidLoan = this.presenter.getModelProperty('money.loans.loans[0]');
      this._createDisplayedOfferModel();
    }

    this._setupDependentDataPromise.resolve();
  };

  this.routeMoneyFlow = function () {
    // UI update
    this._errorInitialized = false;

    if (this._DEBUG) console.log('9. [' + this.id + '] routeMoneyFlow - calls initPage()');

    var loansNavigation = $('#loans-navigation').mogo();
    if (loansNavigation instanceof LoansNavigation) {
      loansNavigation.updateNavigationRoute();
    } else {
      loansNavigation.create('LoansNavigation', {
        presenter: this.presenter
      });
    }
    if (this.loanStateRoutingEnabled) {
      // Used for Live Chat
      var destinationConfigs = window.location.search || '';
      var destinationUrl = this.determineMoneyRoute();
      if (destinationUrl) {
        if (this._getCurrentUrl() === destinationUrl) {
          var lincenseUrl = this._licenseRouting();
          if (destinationUrl === this.paths.loans.preapproval && lincenseUrl) {
            this._history.replaceUrl(lincenseUrl);
          } else {
            this.initPage(); // Already on the correct page
          }
        } else if (destinationUrl === this.paths.loans.fs) {
          this._debugDetails();
          location.replace(destinationUrl);
        } else {
          this._history.replaceUrl(destinationUrl + destinationConfigs);
        }
      } else {
        this.initPage();
      }
    } else {
      this.initPage();
    }
  };

  this._getCurrentUrl = function () {
    return location.pathname.replace(/\/$/, '');
  };

  this._onDeleteAdditionalPayment = function (successCallback, failCallback, data, res) {
    var _this3 = this;

    if (res == 200) {
      var cb = this.presenter.addCallbackToAction(this._liquidLoanPath + '.index_additional_payments', function () {
        _this3.presenter.removeCallbackFromAction(_this3._liquidLoanPath + '.index_additional_payments', cb);
        _this3.presenter.updateModel(_this3._liquidLoanPath, null, successCallback.bind(_this3));
      });
      this.presenter.performAction(this._liquidLoanPath + '.index_additional_payments', null, this._parseAdditionalPayments.bind(this, this._liquidLoanPath));
    } else {
      failCallback();
    }
  };

  this._onCreateAdditionalPayment = function (successCallback, failCallback, data, response) {
    if (response === 200) {
      this.presenter.updateModel(this._liquidLoanPath, null, function (successCallback, failCallback, data, response) {
        this._liquidLoan.additional_payments.updateModel(null, function (successCallback, failCallback, data, response) {
          if (response === 200) {
            successCallback(data, response);
          } else {
            failCallback(data, response);
          }
        }.bind(this, successCallback, failCallback, data, response));
      }.bind(this, successCallback, failCallback, data, response));
    } else {
      failCallback(data, response);
    }
  };

  this.deleteAdditionalPayment = function (successCallback, failCallback) {
    var additionalPaymentIndex = null;
    var liquidLoan = this._liquidLoan;
    var additionalPayments = liquidLoan ? liquidLoan.additional_payments.loan_additional_payments : null;
    if (additionalPayments) {
      for (var i = 0; i < additionalPayments.length; i++) {
        if (additionalPayments[i].payment_type === 'paydown') {
          additionalPaymentIndex = i;
          break;
        }
      }
    }
    this._deleteAdditionalPaymentAction = additionalPaymentIndex != null ? this._liquidLoanPath + '.additional_payments.loan_additional_payments[' + additionalPaymentIndex + '].delete_additional_payment' : null;
    if (this.presenter.hasAction(this._deleteAdditionalPaymentAction)) {
      this._onDeleteAdditionalPaymentCallback = this.presenter.addCallbackToAction(this._deleteAdditionalPaymentAction, this._onDeleteAdditionalPayment.bind(this, successCallback, failCallback));
      this.presenter.performAction(this._deleteAdditionalPaymentAction);
    } else {
      failCallback();
    }
  };

  this.createAdditionalPayment = function (params, successCallback, failCallback) {
    if (this.presenter.hasAction(this._liquidLoanPath + '.create_additional_payment')) {
      this.presenter.performAction(this._liquidLoanPath + '.create_additional_payment', params, this._onCreateAdditionalPayment.bind(this, successCallback, failCallback));
    } else {
      failCallback();
    }
  };

  this.FSBankAccount = function () {
    if (this.presenter.models.money.loans.fs_loans) {
      return this.presenter.models.money.loans.fs_loans.bank_account.bank_id;
    }
    return null;
  };

  this._processUpcomingPayments = function () {
    var payments = [];
    var regularPayment = this._liquidLoan.next_payments;

    var additionalPayments = this._liquidLoan.additional_payments.loan_additional_payments;
    var sortByDate = function sortByDate(a, b) {
      var dateA = moment(a.date).valueOf();
      var dateB = moment(b.date).valueOf();
      return dateA - dateB;
    };
    regularPayment.sort(sortByDate);
    additionalPayments.sort(sortByDate);
    if (additionalPayments.length > 0 && regularPayment.length > 0) {
      var mixedPayments = regularPayment.concat(additionalPayments).sort(sortByDate);
      var currentPayment = mixedPayments.shift();

      while (currentPayment) {
        var nextPayment = mixedPayments.shift();
        // merge two payments when the dates are the same
        if (nextPayment && moment(currentPayment.date).format('MM/DD/YYYY') == moment(nextPayment.date).format('MM/DD/YYYY')) {
          payments.push({
            date: currentPayment.date,
            type: 'combined',
            amount: currentPayment.payment_type ? currentPayment.amount + nextPayment.amount + nextPayment.protection_amount : currentPayment.amount + nextPayment.amount + currentPayment.protection_amount,
            protection_amount: currentPayment.payment_type ? nextPayment.protection_amount : currentPayment.protection_amount,
            regular_amount: currentPayment.payment_type ? nextPayment.amount + nextPayment.protection_amount : currentPayment.amount + currentPayment.protection_amount,
            additional_amount: currentPayment.payment_type ? currentPayment.amount : nextPayment.amount,
            additional_type: currentPayment.payment_type ? currentPayment.payment_type : nextPayment.payment_type,
            frequency: this._liquidLoan.payment_frequency
          });
          currentPayment = null;
        } else {
          // handle non-regular payment
          if (currentPayment.payment_type) {
            payments.push({
              date: currentPayment.date,
              type: currentPayment.payment_type,
              amount: currentPayment.amount,
              frequency: this._liquidLoan.payment_frequency
            });
            if (nextPayment && !nextPayment.payment_type && payments.length == 1) {
              currentPayment = nextPayment;
            } else {
              currentPayment = null;
            }
          } else {
            // handle regular payment
            payments.push({
              date: currentPayment.date,
              type: 'regular',
              amount: currentPayment.amount + currentPayment.protection_amount,
              protection_amount: currentPayment.protection_amount,
              frequency: this._liquidLoan.payment_frequency
            });
            if (payments.length == 2 && payments[0].type != 'regular') {
              currentPayment = null;
            } else {
              currentPayment = nextPayment;
            }
          }
        }
      }
    } else if (regularPayment.length > 0) {
      payments.push({
        date: regularPayment[0].date,
        type: 'regular',
        amount: regularPayment[0].protection_amount ? regularPayment[0].amount + regularPayment[0].protection_amount : regularPayment[0].amount,
        protection_amount: regularPayment[0].protection_amount ? regularPayment[0].protection_amount : 0,
        frequency: this._liquidLoan.payment_frequency
      });
    } else if (additionalPayments.length > 0) {
      payments.push({
        date: additionalPayments[0].date,
        type: additionalPayments[0].payment_type,
        amount: additionalPayments[0].amount,
        frequency: this._liquidLoan.payment_frequency
      });
    }
    return payments;
  };

  this._checkAdditionalPaymentFlowEligibility = function () {
    if (!this._liquidLoan) {
      this._history.goToUrl(this.paths.loans.router);
      return false;
    }

    // Get current URL
    var currentPath = location.pathname;

    if (currentPath.indexOf(this.paths.loans.liquid.add_payment.type_selection) === 0 && currentPath != this.paths.loans.liquid.add_payment.type_selection) {
      if (currentPath.length - this.paths.loans.liquid.add_payment.type_selection.length > 1) {
        // Within Add payment flow (not start screen)
        if (currentPath !== this.paths.loans.liquid.add_payment.pay_in_full) {
          // Add payment flow - Not pay in full flow

          if (currentPath !== this.paths.loans.liquid.add_payment.additional.date_selection) {
            // Add additional payment flow - Not date selection

            if (!this._liquidLoan.create_additional) {
              // Add additional payment flow - not in correct step

              this._history.goToUrl(this.paths.loans.liquid.add_payment.additional.date_selection);
              return false;
            }
          }
        }
      }
    }

    return true;
  };

  /*
      Determines the route of the loans dashboard.
  */
  this.determineMoneyRoute = function () {
    this._errorInitialized = false;

    var _destinationUrl = null;
    var loanStatus = this._getLoanStatus(); // hmm any chance we want to do this sooner?
    var offerStatus = this._getOfferStatus();
    var applicationStatus = this._getApplicationStatus();
    // Note: offerStatus is null if applicationStatus is relevant status, eg 'incomplete'

    if (loanStatus && loanStatus.type === 'liquid') {
      // Handle liquid logic first
      if (loanStatus.status === 'active' || loanStatus.status === 'paid_off' || loanStatus.status === 'closed') {
        _destinationUrl = this.paths.loans.overview;
        // Handel GoEasy loan originated but in pending without detail case
      } else if (loanStatus.status === 'pending') {
        _destinationUrl = this.paths.loans.application_status;
      } else {
        _destinationUrl = this.paths.loans.fs;
      }
    } else if (applicationStatus && applicationStatus.system === 'soa') {
      // During Loan Application
      _destinationUrl = this.paths.loans.application_status;
    } else if (offerStatus) {
      // Check for non-null offer status
      if (offerStatus === 'declined' || offerStatus === 'active' || offerStatus === 'enhanced') {
        _destinationUrl = this.paths.loans.preapproval;
      } else if (offerStatus === 'expired') {
        _destinationUrl = this.paths.loans.paid_off;
      } else if (offerStatus === 'refresh') {
        if (loanStatus && loanStatus.status === 'paid_off') {
          _destinationUrl = this.paths.loans.paid_off;
        } else {
          _destinationUrl = this.paths.loans.preapproval;
        }
      }
    } else {
      // Offer is null
      // Note: when offer is null, loan status cannot be paid off

      // Check for loan status
      if (loanStatus && loanStatus.status !== 'paid_off') {
        if (loanStatus.status === 'pending') {
          if (applicationStatus.status === 'agreements') {
            // Agreements
            var agreementsStatus = this._getAgreementsStatus();
            if (agreementsStatus) {
              if (agreementsStatus.type === 'manual') {
                _destinationUrl = this.paths.loans.fs;
              } else {
                _destinationUrl = this.paths.loans.application;
              }
            } else {
              _destinationUrl = this.paths.loans.fs;
            }
          } else if (applicationStatus.status === 'bank') {
            // Bank
            var bankStatus = this._getBankVerificationStatus();
            if (bankStatus) {
              if (bankStatus && bankStatus.status !== 'not_required' && bankStatus.status !== 'verified') {
                if (bankStatus.type === 'manual' || bankStatus.status === 'submitted') {
                  _destinationUrl = this.paths.loans.fs;
                } else {
                  // type: auto or null && status not submitted
                  if (bankStatus.status === 'errored') {
                    _destinationUrl = this.paths.loans.bank_verification_error;
                  } else if (bankStatus.status === 'failed') {
                    _destinationUrl = this.paths.loans.fs;
                  } else {
                    _destinationUrl = this.paths.loans.bank_verification;
                  }
                }
              }
            } else {
              _destinationUrl = this.paths.loans.fs;
            }
          }
        } else if (loanStatus.status === 'active') {
          _destinationUrl = this.paths.loans.fs;
        }
      } else {
        // Check application status
        // Bank and agreements statuses checked as part of loanStatus === 'pending', only status not accounted for is incomplete
        if (applicationStatus && (applicationStatus.status === 'incomplete' || applicationStatus.status === 'complete')) {
          // complete status only used for liquid loans
          _destinationUrl = this.paths.loans.fs;
        } else if (applicationStatus) {
          if (applicationStatus.status === 'agreements') {
            // Agreements
            var agreementsStatus = this._getAgreementsStatus();
            if (agreementsStatus) {
              if (agreementsStatus.type === 'manual') {
                _destinationUrl = this.paths.loans.fs;
              } else {
                _destinationUrl = this.paths.loans.application;
              }
            } else {
              _destinationUrl = this.paths.loans.fs;
            }
          } else if (applicationStatus.status === 'bank') {
            // Bank
            var bankStatus = this._getBankVerificationStatus();
            if (bankStatus) {
              if (bankStatus && bankStatus.status !== 'not_required' && bankStatus.status !== 'verified') {
                if (bankStatus.type === 'manual' || bankStatus.status === 'submitted') {
                  _destinationUrl = this.paths.loans.fs;
                } else {
                  // type: auto or null && status not submitted
                  if (bankStatus.status === 'errored') {
                    _destinationUrl = this.paths.loans.bank_verification_error;
                  } else if (bankStatus.status === 'failed') {
                    _destinationUrl = this.paths.loans.fs;
                  } else {
                    _destinationUrl = this.paths.loans.bank_verification;
                  }
                }
              }
            } else {
              _destinationUrl = this.paths.loans.fs;
            }
          }
        }
      }
    }

    return _destinationUrl;
  };

  this._viewHighCostOfferMessage = function () {
    var _this4 = this;

    if (this.presenter.hasAction('money.displayed_offer.0.update_offer')) {
      this.presenter.performAction('money.displayed_offer.0.update_offer', {
        accept_high_cost_of_credit: true
      }, function () {
        _this4.presenter.updateModel('money.offers', null, _this4._enableLicenseCloseCtas);
      });
    }
  };

  this._licenseRouting = function () {
    if (this._activeOffer.getOfferData() && this.presenter.hasAction('money.displayed_offer.0.update_offer') && this.presenter.getModelProperty('money.displayed_offer.0.is_high_cost_of_credit') === true) {
      var offerName = this._activeOffer.getOfferName();
      if (offerName === 'liquid') {
        return this.paths.loans.manitoba_liquid_license;
      }
      if (offerName === 'mini') {
        return this.paths.loans.manitoba_mini_license;
      }
    }
    return null;
  };

  this._enableLicenseCloseCtas = function () {
    $('.manitoba-license').find('a.btn').removeClass('disabled');
  };

  /*
      Returns whether or not the user is eligible for the loan product. This means the user has
      not passed credit approval, and will not have offers nor access to the loans index.
  */
  this._isEligibleForLoanProduct = function () {
    if (this.presenter.getModelProperty('money.offers.referral') === null && (this.presenter.getModelProperty('account.credit_check_decision') !== 'approved' && this.presenter.getModelProperty('account.credit_check_decision') !== 'soft_declined' || this.presenter.getModelProperty('account.credit_check_decision') === 'soft_declined' && moment(this.presenter.getModelProperty('account.credit_check_decision_expires_at')).isAfter(moment()) || this.presenter.getModelProperty('money.offers.offers') && this.presenter.getModelProperty('money.offers.offers.length') === 0)) {
      return false;
    }
    return true;
  };

  /*
      Gets the status of an application that is in progress.
       Returns:
        system
          fs
        status
          null - no application flow or user already has an active loan
          incomplete - application flow is incomplete
          bank - application flow is in bank verification step
          agreements - application flow is in agreements step
         system
          soa
        status
          digital_status property in loan application
  */
  this._getApplicationStatus = function () {
    if (!this._isEligibleForLoanProduct()) return null;

    if (this.presenter.getModelProperty('money.loans.loans.length')) {
      /*
          This assumes user with liquid loan in any state means that there cannot
          be a loan application in progress, except for level up.
      */
      if (this.hasCreatedLoanApplication() && this._getOfferStatus() === 'active') {
        if (this._loanApplications[0].getLoanApplicationOfferId() === this._activeOffer.getOfferData().id) {
          return {
            system: 'soa',
            status: this._loanApplications[0].getStatus()
          };
        }
      }
      return null;
    }
    if (this.hasCreatedLoanApplication()) {
      // DLA
      if (this._loanApplications[0].hasSubmittedEmployment() || this._loanApplications[0].getStatus() === 'declined') {
        return {
          system: 'soa',
          status: this._loanApplications[0].getStatus()
        };
      }
    } else if (this.presenter.getModelProperty('money.loans.fs_loans.loan_status') === 'active') {
      // Active loan, no application status
      return null;
    } else if (this.presenter.getModelProperty('money.loans.fs_loans.loan_application_status') !== 'none') {
      // incomplete
      if (this.presenter.getModelProperty('money.loans.fs_loans.loan_application_status') === 'incomplete') {
        // check expiry
        if (!this._activeOffer.getOfferData()) {
          // when user has expired mini offer this invalides the application. good
          // when user has expired mini offer and active liquid offer this doesnt invalidate the application. bad.
          return null;
        }
        return {
          status: 'incomplete',
          system: 'fs' // system property for future-proofing
        };
      }
      if (this.presenter.getModelProperty('money.loans.fs_loans.loan_application_status') === 'complete') {
        // Also check bank verification and agreements
        var bankVerificationStatus = this._getBankVerificationStatus();
        if (bankVerificationStatus) {
          bankVerificationStatus = bankVerificationStatus.status;
          var agreementsStatus = this._getAgreementsStatus();
          if (bankVerificationStatus !== 'verified' && bankVerificationStatus !== 'not_required') {
            return {
              status: 'bank',
              system: 'fs'
            };
          }
          if (agreementsStatus !== 'signed') {
            return {
              status: 'agreements',
              system: 'fs'
            };
          }
        } else {
          // Liquid application complete
          return {
            status: 'complete',
            system: 'fs'
          };
        }
      }

      // Return default state
      return {
        status: this.presenter.getModelProperty('money.loans.fs_loans.loan_application_status'),
        system: 'fs' // system property for future-proofing
      };
    }

    // fs_loans.loan_application_status == 'none'
    // console.log(`_getApplicationStatus: return null`);
    return null;
  };

  this._getApplicationLender = function () {
    if (!this._isEligibleForLoanProduct()) return null;

    if (this.presenter.getModelProperty('money.loans.loans.length')) {
      /*
          This assumes user with liquid loan in any state means that there cannot
          be a loan application in progress. This will change when we accommodate return
          offers for paid off asset loans.
      */
      return null;
    }
    if (this.hasCreatedLoanApplication()) {
      return this.getLenderName(this._loanApplications[0].getApplicationLender());
    }
    return null;
  };

  /*
      Returns bank verification statuses:
       Returns:
        status:
          not_required - user does not require bank verification
          required - user needs to complete bank verification
          submitted - user has submitted bank verification
          failed - user has failed bank verification
          errored - there is an error completing bank verification
          verified - bank is verified
        type:
          auto - auto bank verification
          manual - manual bank verification
   */
  this._getBankVerificationStatus = function () {
    if (this.presenter.getModelProperty('money.loans.fs_loans.loan_application_status') === 'complete' && (this.presenter.models.money.loans.fs_loans.loan_status === 'none' || this.presenter.models.money.loans.fs_loans.loan_status === 'pending' || this.presenter.models.money.loans.fs_loans.loan_status === 'paid_off')) {
      if (this.presenter.models.money.loans.fs_loans.bank_account.bank_verification_status) {
        var type = this.presenter.getModelProperty('money.loans.fs_loans.bank_account.bank_verification_type') || this.presenter.getModelProperty('money.loans.fs_loans.bank_account.type');
        return {
          status: this.presenter.models.money.loans.fs_loans.bank_account.bank_verification_status,
          type: type
        };
      }
    }
    return null;
  };

  /*
      Returns loan agreements status. Returns agreements status for any loan application in progress.
       Returns:
        null - there are no agreements
        pending - agreements are being generated
        error - there was an error generating agreements
        ready - agreements are ready for the user to be signed
        signed - agreements have been signed
  */
  this._getAgreementsStatus = function () {
    if (!this._isEligibleForLoanProduct()) return null;
    if (this.presenter.getModelProperty('money.loans.fs_loans.loan_application_status') === 'complete' && (this.presenter.models.money.loans.fs_loans.loan_status === 'pending' || this.presenter.models.money.loans.fs_loans.loan_status === 'none' || this.presenter.models.money.loans.fs_loans.loan_status === 'paid_off')) {
      var bvStatus = this._getBankVerificationStatus();
      if (bvStatus && (bvStatus.status === 'not_required' || bvStatus.status === 'verified')) {
        return this.presenter.models.money.loans.fs_loans.agreements.status;
      }
    }
    return null;
  };

  /*
      Returns loan status with type of loan and status. Returns null if no loan.
       type: liquid/fs_loan
      status: - liquid loan states,
              - loan_status states: pending (checked out, awaiting bank verification and/or agreements),
                                    active
                                    paid_off
                                    closed
  */
  this._getLoanStatus = function () {
    if (!this._isEligibleForLoanProduct()) return null;

    // {type:liquid/fs_loan, status: loan_status or loan.status}
    if (this.presenter.getModelProperty('money.loans.loans[0].product_type') === 'liquid') {
      return {
        type: 'liquid',
        status: this.presenter.models.money.loans.loans[0].mogo_contract_status.toLowerCase() // active/paid_off/closed
      };
    }
    if (this.presenter.models.money.loans && this.presenter.models.money.loans.fs_loans && this.presenter.models.money.loans.fs_loans.loan_status && this.presenter.models.money.loans.fs_loans.loan_status !== 'none') {
      return {
        type: 'fs_loan',
        status: this.presenter.models.money.loans.fs_loans.loan_status.toLowerCase() // pending/paid_off/active
      };
    }

    return null;
  };

  this._getLoanLender = function () {
    if (!this._isEligibleForLoanProduct()) return null;

    if (this.presenter.getModelProperty('money.loans.loans[0].product_type') === 'liquid') {
      return this.getLenderName(this.presenter.models.money.loans.loans[0].lender_id);
    }

    return null;
  };

  this.getLoanLenderId = function () {
    if (!this._isEligibleForLoanProduct()) return null;

    if (this.presenter.getModelProperty('money.loans.loans[0].product_type') === 'liquid') {
      return this.presenter.models.money.loans.loans[0].lender_id;
    }

    return null;
  };

  this.getLenderName = function (id) {
    if (id === 1) return 'Mogo';
    if (id === 2) return 'Goeasy';
    return false;
  };

  // TODO: Create Loan Class
  // Returns loan ID from active liquid loan
  this.getLoanId = function () {
    if (!this._isEligibleForLoanProduct()) return null;

    if (this.presenter.getModelProperty('money.loans.loans[0].product_type') === 'liquid') {
      return this.presenter.models.money.loans.loans[0].loan_id;
    }

    return null;
  };

  this.getLoanApprovedProductId = function () {
    if (!this._isEligibleForLoanProduct()) return null;

    if (this.presenter.getModelProperty('money.loans.loans[0].product_type') === 'liquid') {
      return this.presenter.models.money.loans.loans[0].approved_product_id;
    }

    return null;
  };

  // return true if it is soft declined AND credit_check_decision_expires_at is passed
  this.isSoftDeclineExpired = function () {
    return this.presenter.hasAction('money.offers.get_credit_detail') && this.presenter.getModelProperty('account.credit_check_decision') === 'soft_declined';
  };

  // Returns true when Trust Science decision is still pending in relation to loan offers
  this.isPendingLoanOfferDecision = function () {
    return this.presenter.getModelProperty('account.credit_check_decision') === 'trust_science_pending';
  };

  /*
    Gets the status of an offer.
     As of Liquid type returns null. 20190709
     Returns:
      declined - member is not eligible for any offer
      active - member has an active offer OR member has level up offer (levelup_loan_id == loanId)
      enhanced - member has an enhanced active offer
      expired - offer has expired and member cannot refresh (only for paid off scenario)
      refresh - member can refresh when offer expires (for both paid off scenario and first offer scenario. Note: first offer can always be refreshed)
      null - no offer and cannot refresh
  */
  this._getOfferStatus = function () {
    if (!this._isEligibleForLoanProduct()) {
      return 'declined';
    }
    if (this.isPendingLoanOfferDecision()) {
      // since we share same page with active..
      return 'active';
    }
    var ls = this._getLoanStatus();

    if (!this._activeOffer) {
      console.warn('_getOfferStatus: this._activeOffer is required at this point.');
      return;
    }
    var loanReferenceId = this._activeOffer.getLoanReferenceId();
    var loanId = this.getLoanId();

    // Handle Liquid loans first
    // * it is not possible to have level up offer for fs_loan
    if (ls && ls.type === 'liquid') {
      // Loan status can be paid_off or active during level up
      if ((ls.status === 'paid_off' || ls.status === 'active') && this._activeOffer.getOfferData() && loanId === loanReferenceId) {
        return 'active';
      }
      return null;
    }
    if (ls && ls.type === 'fs_loan' && ls.status === 'active') {
      return null;
    }

    // fs_loan
    var as = this._getApplicationStatus();
    // (as is null when !this._activeOffer.getOfferData() is true : intention is for an expired offer check [apps for expired offers are not valid apps])
    // TODO: would be great to move this to determineMoneyRoute instead, like SOA app status check, but hard to understand impact
    if (as && as.system === 'fs' && this._activeOffer.getOfferData() && this._activeOffer.getOfferName() === 'mini' && (as.status === 'incomplete' || as.status === 'complete' || as.status === 'agreements' || as.status === 'bank')) {
      return null;
    }
    if (this._activeOffer.getOfferData()) {
      if (this._activeOffer.getOfferType() === 'enhanced') {
        return 'enhanced';
      }
      // https://mogofintech.atlassian.net/browse/SPEND-1134
      if (this._activeOffer.getOfferData().name === 'lendful' && this.presenter.hasAction('money.offers.get_credit_detail')) {
        return 'refresh';
      }
      return 'active';
    }
    var expiredOffer = this._expiredOffer.getOfferData() && !this._activeOffer.getOfferData();
    if (expiredOffer && !this.presenter.hasAction('money.offers.get_credit_detail') && this.presenter.getModelProperty('money.loans.fs_loans.loan_status') !== 'paid_off') {
      return 'declined';
    }
    if (this.presenter.hasAction('money.offers.get_credit_detail')) {
      return 'refresh';
    }
    if (this._expiredOffer.getOfferData()) {
      return 'expired';
    }
    return null;
  };

  this._getDaysBeforeExpiration = function () {
    return this._activeOffer ? this._activeOffer.getDaysBeforeExpiration() : null;
  };

  this._createDisplayedOfferModel = function () {
    if (this.presenter.models.money && (this.presenter.models.money.displayed_offer || typeof this.presenter.models.money.displayed_offer === 'undefined')) {
      var offer = this._activeOffer.getOfferData();
      if (offer) {
        this.presenter.createModel('money.displayed_offer', {
          data: [offer],
          isExpiredOffer: false
        });
      } else {
        offer = this._expiredOffer.getOfferData();

        this.presenter.createModel('money.displayed_offer', {
          data: [offer],
          isExpiredOffer: true
        });
      }
    }
  };

  /*
    Gets loan application status for analytics, the logic to align
    client analytics data will be scoped in this method,
     IE bank_service_in_progress is In Progress
  */
  this._getStatusAnalytics = function () {
    var string = '';

    var lastSavedPoint = this._loanApplications[0].getLastSavedPoint() ? this._loanApplications[0].getLastSavedPoint() : false;
    var applicationStatus = this._loanApplications[0].getStatus() ? this._loanApplications[0].getStatus() : '';
    var expirationDate = this._getDaysBeforeExpiration();

    var formattedStatusString = applicationStatus.split('_').map(function (currentValue, index) {
      return currentValue.charAt(0).toUpperCase() + currentValue.slice(1);
    }).join(' ');

    // Only In progress will need a last saved point
    if (applicationStatus !== 'in_progress' && applicationStatus !== 'bank_service_in_progress') {
      string = formattedStatusString;
    } else {
      if (applicationStatus === 'bank_service_in_progress') formattedStatusString = 'In Progress';
      string = formattedStatusString + ' -  ' + lastSavedPoint;
    }

    return expirationDate <= 7 ? string + ' - expiring' : string;
  };

  this._checkRequestErrors = function () {
    for (var key in this._requestErrors) {
      this._requestErrors[key].retry();

      delete this._requestErrors[key];
    }
  };

  this._debugDetails = function () {
    try {
      var fullstoryUserVarsData = {
        'Activated Date': this.presenter.getModelProperty('account.activated_at'),
        'Offer Status': this._getOfferStatus()
      };

      var fullstoryConsoleData = {
        _determineMoneyRoute: this.determineMoneyRoute(),
        account: {
          products_offer_expires_at: this.presenter.getModelProperty('account.products_offer_expires_at'),
          credit_seeker_status: this.presenter.getModelProperty('account.credit_seeker_status'),
          credit_check_decision: this.presenter.getModelProperty('account.credit_check_decision')
        },
        applications: {
          create_loan_application: this.presenter.hasAction('money.applications.create_loan_application'),
          loan_applications: this.presenter.getModelProperty('money.applications.loan_applications[0]')
        },
        offers: {
          OfferStatus: this._getOfferStatus()
        },
        fs: {
          AgreementsStatus: this._getAgreementsStatus(),
          fs_loans: this.presenter.getModelProperty('money.loans.fs_loans')
        }
      };

      if (this._activeOffer.getOfferData()) {
        // fullstoryConsoleData.offers.offerType = this._activeOffer.getOfferType();
        fullstoryConsoleData.offers.offerName = this._activeOffer.getOfferName();
        fullstoryUserVarsData.OfferProduct = this._activeOffer.getOfferName();
      }

      if (this._activeOffer.getOfferName() === 'liquid' && !this.presenter.hasAction('money.applications.create_loan_application')) {
        FS.event('Mogo App Debug', {
          name: 'Applications check',
          details: 'Missing create_loan_application relink',
          OfferStatus: this._getOfferStatus(),
          OfferName: this._activeOffer.getOfferName(),
          applications: this.presenter.getModelProperty('money.applications')
        });
      }

      FS.log('debug', fullstoryConsoleData);
      FS.setUserVars(fullstoryUserVarsData);

      // console.log(fullstoryConsoleData);
    } catch (e) {}
  };

  this.destroy = function () {
    if (this._onGetLoansModelCallback) {
      this.presenter.removeCallbackFromAction('account.index_loans', this._onGetLoansModelCallback);
    }

    if (this._onGetLoanOffersCallback) {
      this.presenter.removeCallbackFromAction('account.get_offer', this._onGetLoanOffersCallback);
    }

    if (this._onGetLoanApplicationsCallbackId) {
      this.presenter.removeCallbackFromAction(this._indexLoanApplicationsAction, this._onGetLoanApplicationsCallbackId);
    }

    if (this._activeLoanModelCallbackId) {
      this.presenter.removeCallbackFromAction('loan_' + this.presenter.models.money.loans.loans[0].product_type + '.self', this._activeLoanModelCallbackId);
    }

    if (this._onDeleteAdditionalPaymentCallback) {
      this.presenter.removeCallbackFromAction(this._deleteAdditionalPaymentAction, this._onDeleteAdditionalPaymentCallback);
    }

    this.presenter.removeComputedVariable('offerExpireDate');

    this.presenter.removeComputedVariable('expiry_days');

    this.presenter.removeComputedVariable('loanState');

    this.presenter.removeComputedVariable('offerState');

    this.presenter.removeComputedVariable('applicationState');

    this.presenter.removeComputedVariable('agreementsState');

    this.presenter.removeComputedVariable('activeOfferName');

    this.presenter.removeComputedVariable('expiredOfferName');

    this.presenter.removeComputedVariable('previousOfferName');

    this.presenter.removeComputedVariable('daysBeforeExpiry');

    this.presenter.removeComputedVariable('loanLenderId');

    this.presenter.removeComputedVariable('digitalLoanStatus');

    if (this.presenter.getModelProperty('money.displayed_offer')) {
      this.presenter.removeModelProperty('money.displayed_offer');
    }
  };
}